import type { FaireProductEntity } from "../../entity_types/product";

export const p_5qmvmj9tcw: FaireProductEntity = {
  token: "p_5qmvmj9tcw",
  type: "product",
  name: "Amazing Grace Bath Balm",
  brandToken: "b_9h3th02x",
  brandName: "Musee",
  imageUrl:
    "https://cdn.faire.com/fastly/eb5c2b79253d256625c9abaa91be6733c05a8ae61e6d5dafeb00e6096bdac3e1.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6666a0c0477c642c3886d9d9cb88b64ce0b286ce8fe6c54689c950fa280dc19b.jpeg",
    "https://cdn.faire.com/fastly/67a2f832290b78f1d2160eca94b4668ac8d164bdc8e9714da7c06f5b3e7df634.png",
    "https://cdn.faire.com/fastly/1b1a30a675f477179a6f78ffed269db515c03617873e99d62601fa8858c11902.png",
  ],
  priceDollars: 4.5,
  description:
    'How sweet the sound of soaking in a tranquil and relaxing bath at the end of a long day. This pure and fragrant bath balm will soothe your soul as it dissolves from white to red, leaving a gracious reminder in the bath.\n\nFragrance - Lily of the Valley\n\nSurprise - Cross inside.\n\n𝐆𝐫𝐞𝐚𝐭 𝐟𝐨𝐫:\n• Gifting\n• Moisturizing\n• Sustainable Gifts\n• Natural Gifts\n• Cleansing\n• Gentle on skin\n• All Ages\n• Spiritual Products\n\nWe call our Bath Bombs "Bath Balms" because they are hydrating and nourishing and prefer to use a word not associated with destruction.',
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:30.943Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
